import { Spacing } from '@treneo/shared/themes';

import { styled } from '../styled';

import { Box } from './box';

export const SingleLine = styled(Box)`
  display: flex;
  gap: ${Spacing.xsmall};
`;
